var rmUtil = require("../rmlibrary_old/util");
var PDFBlockNode = require("./block");

function PDFInlineBlockNode() {
    PDFBlockNode.apply(this, arguments);
}
rmUtil.inherits(PDFInlineBlockNode, PDFBlockNode);

PDFInlineBlockNode.prototype.isInlineBlock = function() {
    return true;
};

PDFInlineBlockNode.prototype._getOptions = function() {
    var ret = PDFBlockNode.prototype._getOptions.call(this);
    ret.verticalAlign = this.computedStyles.verticalAlign;
    return ret;
};

PDFInlineBlockNode.prototype.generate = function(pdf) {
    return pdf.inlineBlock(
        this._getOptions(),
        this.children.map(function(child) {
            return child.generate(pdf);
        })
    );
};

module.exports = PDFInlineBlockNode;
